import { app } from '@/main'

//日期格式
export const dateFormats = {
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
  time_no_sec: 'HH:mm'
}

//pagination
export const defaultPagination = {
  // 當前頁數
  current: 1,
  // 總筆數
  total: 0,
  showTotal: total => app.$t('i18n_total_count', { total: total }),
  // 每頁多少筆數
  pageSize: 30,
  pageSizeOptions: ['30', '50', '100', '150', '200'],
  showSizeChanger: true,
  showSizeChange: (current, pageSize) => (this.pageSize = pageSize),
  // [REF] https://github.com/ant-design/ant-design/issues/13619
  // [REF] https://github.com/react-component/pagination/blob/72f5c4b000dc088a45a9bf257d4e7ef841b4ca51/src/locale/zh_CN.js#L3
  locale: {
    items_per_page: '条/页',
    jump_to: '跳至',
    page: '页'
  },
  // 跳轉至指定頁數
  showQuickJumper: true
}

//pagination 長度為0格式
export const pageEmpty = {
  total: 0
}

//ant design vue i18n
export const customText = () => {
  return {
    date: {
      lang: {
        today: app.$t('i18n_today'),
        yearFormat: 'YYYY'.concat(app.$t('i18n_year'))
      }
    },
    emptyText: 'i18n_empty_data',
    errorText: 'i18n_load_fail_retry'
  }
}

/**
 * ant design date picker 用的locale
 */
export const datePickerLocale = () => {
  return {
    lang: {
      now: app.$t('i18n_now'),
      ok: app.$t('i18n_confirm'),
      yearFormat: 'YYYY',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      timeSelect: app.$t('i18n_select_time'),
      dateSelect: app.$t('i18n_select_date')
    }
  }
}
